import React, { Component } from "react";

import { Navbar } from "reactstrap";

import { connect } from "react-redux";
import * as _ from "lodash";
import PropTypes from "prop-types";

import { toggleSidebar } from "../../redux/actions/sidebarActions";
import CompanyDropdown from "./CompanyDropdown";

class NavbarComponent extends Component {
  toggleSidebar = () => {
    this.props.dispatch(toggleSidebar());
  };

  /**
   * Render method for the component
   */
  render() {
    return (
      <Navbar
        color="white"
        light
        expand
        style={{ zIndex: 50, paddingBottom: "14px", paddingTop: "14px" }}
        className={!this.props.sidebar.isOpen ? "closed" : ""}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <span
            className="sidebar-toggle d-flex mr-2"
            onClick={this.toggleSidebar}
          >
            <i className="hamburger align-self-center" />
          </span>
          <CompanyDropdown
            domains={this.props.domains}
            client={this.props.client}
          />
        </div>
        <SearchEmitter />
      </Navbar>
    );
  }
}

NavbarComponent.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.string,
  }),
  client: PropTypes.shape({
    company: PropTypes.string,
  }),
};

import { domains } from "../../utils/session";
import SearchEmitter from "./SearchEmitter";

export default connect((state) => ({
  sidebar: state.sidebar,
  layout: state.layout,
  user: state.user.data,
  client: state.client.data,
  domains: domains,
}))(NavbarComponent);
